<template>
  <div class="shujujiaoyi">
    <div class="top new-top blue-text center-flex">
      <div class="display-flex center-flex">
        <img src="@/assets/images/jiaoyi1@2x.png" alt="" class="icon-zb">
        <span class="fs20 ml10 title-text">数据交易大厅</span>
      </div>
      <div>
        <GsMore @click="dataChangeClick">查看更多</GsMore>
      </div>
    </div>
    <div class="hot-bottom-wrap">
      <GsSkeleton v-if="loading" :rows="2" variant="card" />
      <div v-else-if="dataChangeList && dataChangeList.length > 0" class="hot-bottom">
        <div
          v-for="(item, index) in dataChangeList"
          :key="index"
          class="data-card gs-card"
        >
          <div class="data-title">
            <div class="data-name">
              {{ cardTitle(item) }}
            </div>
            <div class="data-type" :class="{ 'is-wait': !hasBuyer(item) }">{{ stageLabel(item) }}</div>
          </div>
          <div class="data-detail">
            <div class="detail">
              <span class="detail-target">标的：{{ cardTarget(item) }}</span>
              <span class="detail-amount">金额：{{ cardAmount(item) }}</span>
            </div>
            <div class="detail-icon">
              <GsMore size="xs" @click="handleRowClick(item)">查看交易</GsMore>
            </div>
          </div>
          <div class="data-footer">
            <div class="footer">
              <div class="crile" />
              <div class="w130 opa6 footer-label">
                数据交易所:
              </div>
              <div class="ellipsis-one opa6 w-name" :title="cardExchange(item)">
                {{ cardExchange(item) }}
              </div>
            </div>
            <div class="footer">
              <div class="crile" />
              <div class="opa6 footer-label">
                交易双方:
              </div>
              <div class="footer-num ellipsis-one" :title="cardParty(item)">
                {{ cardParty(item) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <NoData class="mt10" v-else/>
      <!-- <el-table
        ref="dataTable"
        :data="dataChangeList"
        class="table-content"
        border
        @row-click="handleRowClick"
        row-class-name="hand-cursor"
        :height="tableHeight"
        @mouseenter.native="stopAutoScroll"
        @mouseleave.native="startAutoScroll"
      >
        <el-table-column
          prop="enterpriseName"
          label="登记数据名称"
          header-align="center"
          align="left"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="enterpriseName"
          label="数据登记类型"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ transFormEnum(registrationDataList, scope.row.registrationDataType) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="registrationPrincipalName"
          label="登记主体名称"
          header-align="center"
          align="left"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="registrationPlatform"
          label="登记平台"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="registeredAddressName"
          label="登记地区"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="findSellDataName"
          label="找/卖数据"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
        />
      </el-table> -->
    </div>
  </div>
</template>

<script>
import { getTradeList } from "@/api/api";
import { enumType } from '@/utils/enum.js'
import { getDataType } from '@/api/Layout/index.js'
import NoData from '@/components/NoData/index.vue'
import { P } from '@/router/paths'
import { tradeProgressValue } from '@/utils/tradeProgress'

export default {
  name: 'DataChangeIndex',
  components: {NoData},
  data() {
    return {
      loading: true,
      dataChangeList: [],
      registrationDataList: [],
      tableHeight: null,
      scrollInterval: null,
      isHovering: false,
      rowHeight: 50, // 预估每行高度，根据实际样式调整
      headerHeight: 40 // 表头高度
    };
  },
  computed: {
    transFormEnum() {
      return function (enumList, value, multi) {
        if(value) {
          let valObj = []
          if(multi) {
            valObj = JSON.parse(value)
          } else {
            valObj = value.split(',').map(item => item.trim())
          }
          let labelListEnum = []
          if(enumList && enumList.length > 0) {
            enumList.forEach(item => {
              valObj && valObj.forEach(itemObj => {
                if(itemObj === item.value) {
                  labelListEnum.push(item.label)
                }
              })
            })
          }
          return labelListEnum.join(',')
        } else {
          return ''
        }
      }
    }
  },
  watch: {
    dataChangeList(newVal) {
      this.$nextTick(() => {
        this.adjustTableHeight();
        if (newVal.length > 5) {
          this.startAutoScroll();
        } else {
          this.stopAutoScroll();
        }
      });
    }
  },
  created() {
    this.loadEnterpriseList();
    this.getData('sys_enterprise_register_data_type')
    // this.getData('sys_enterprise_data_product')
    // this.getData('sys_business_type')
    // this.regionArea()
    // this.applicationScenarioGet()
  },
  methods: {
    adjustTableHeight() {
      if (this.dataChangeList.length <= 5) {
        // 行数≤5时，高度自适应
        const totalHeight = this.headerHeight + (this.dataChangeList.length * this.rowHeight);
        this.tableHeight = totalHeight;
      } else {
        // 行数>5时，固定高度为5行高度+表头高度
        this.tableHeight = this.headerHeight + (5 * this.rowHeight);
      }
    },
    startAutoScroll() {
      if (this.dataChangeList.length <= 5 || this.isHovering) return;
      // 表格已注释，Vue3 下 $refs.dataTable 不存在，不能再取 $el
      const table = this.$refs.dataTable
      if (!table) return
      
      this.stopAutoScroll();
      
      const root = table.$el || table
      const tableWrapper = root.querySelector && root.querySelector('.el-table__body-wrapper');
      if (!tableWrapper) return;
      
      let scrollStep = 1;
      let isScrollingDown = true;
      
      this.scrollInterval = setInterval(() => {
        // if (!tableWrapper) return;
        // if (this.shouldScroll && tableWrapper) {
        //   // 如果已经滚动到底部，回到顶部
        //   if (tableWrapper.scrollTop + tableWrapper.clientHeight >= tableWrapper.scrollHeight) {
        //     tableWrapper.scrollTop = 0;
        //   } else {
        //     tableWrapper.scrollTop += 1; // 每次滚动1px
        //   }
        // }
        if (!tableWrapper) return;
        
        if (isScrollingDown) {
          // 向下滚动
          if (tableWrapper.scrollTop + tableWrapper.clientHeight >= tableWrapper.scrollHeight - 1) {
            // 到底部了，改为向上滚动
            isScrollingDown = false;
            scrollStep = -1;
          }
        } else {
          // 向上滚动
          if (tableWrapper.scrollTop <= 1) {
            // 到顶部了，改为向下滚动
            isScrollingDown = true;
            scrollStep = 1;
          }
        }
        
        tableWrapper.scrollTop += scrollStep;
      }, 50);
    },
    stopAutoScroll() {
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
    async getData(type) {
      try {
        const res = await getDataType(type);
        if (res?.data?.length > 0 && type === 'sys_enterprise_register_data_type') {
          this.registrationDataList = enumType(res.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    cardTitle(item) {
      return (item && (item.tradeName || item.datasetName)) || '数据交易'
    },
    cardTarget(item) {
      return (item && item.datasetName) || '—'
    },
    cardAmount(item) {
      return (item && (item.transactionAmount || item.priceDescription)) || '面议'
    },
    hasBuyer(item) {
      return !!(item && (item.buyListingId || item.buyListingName))
    },
    stageLabel(item) {
      return this.hasBuyer(item) ? `阶段 ${tradeProgressValue(item.transactionProgress)}/6` : '待撮合'
    },
    cardExchange(item) {
      return (item && item.exchangeName) || '—'
    },
    cardParty(item) {
      const sell = (item && item.sellListingName) || '待定'
      const buy = this.hasBuyer(item) ? ((item && item.buyListingName) || '待定') : '待撮合'
      return `${sell} → ${buy}`
    },
    loadEnterpriseList() {
      // 公开侧只展示已发布的数据集（挂牌标的），交易台账不对外
      const formData = {
        pageNum: 1,
        // 一行 4 个，最多 3 行
        pageSize: 12,
        whetherPublish: '1'
      };
      getTradeList(formData).then((response) => {
        this.dataChangeList = (response && response.rows) || [];
      }).catch(() => {
        this.dataChangeList = [];
      }).finally(() => {
        this.loading = false
      });
    },
    handleRowClick(row) {
      this.$router.push(P.hallDetail(row.id));
    },
    dataChangeClick() {
      this.$router.push(P.hall)
    }
  }
};
</script>

<style scoped>
.top {
  font-weight: 700;
}
/* 外层只是占位，网格只在内层 .hot-bottom 上生效（原来两层同名嵌套，导致卡片被压成 130px） */
.hot-bottom-wrap {
  width: 100%;
  background: transparent;
}
.hot-bottom {
  display: grid;
  /* 一行 4 个，数据够时最多 3 行 */
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-auto-rows: 212px;
  gap: 12px 10px;
  width: 100%;
  background: transparent;
}
.shujujiaoyi {
  background: transparent;
  box-shadow: none;
  border: 0;
  padding: 0 0 4px;
}
.data-card {
  /* 一行三个（由 .hot-bottom 的 grid 控制），一页三行 */
  width: 100%;
  min-width: 0;
  background: #fff;
  border: 1px solid rgba(215, 230, 255, 0.85);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(3, 52, 87, 0.08);
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: nowrap;
  margin: 0;
  overflow: hidden;
  box-sizing: border-box;
}
.data-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  background: #ecf5ff;
}
.data-title {
  background-image: url('@/assets/images/编组 15@2x.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 52px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
  padding: 0 12px;
  box-sizing: border-box;
}
.data-name {
  flex: 1 1 auto;
  min-width: 0;
  height: 28px;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 16px;
  color: #111824;
  line-height: 28px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.data-type{
  flex: 0 0 auto;
  max-width: 46%;
  height: 24px;
  padding: 0 8px;
  background: linear-gradient( 263deg, #FF4F20 0%, #FF0000 100%);
  box-shadow: 2px 2px 4px 0px rgba(239,66,66,0.3);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.data-detail{
  padding: 8px 10px;
  height: 88px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 14px;
  color: #111824;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  background-color: #FFFFFF;
}
.footer-label {
  flex: 0 0 auto;
  white-space: nowrap;
}
.detail-target,
.detail-amount {
  display: block;
}
.detail-amount {
  color: #FF7001;
}
.detail {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  opacity: .6;
}
.detail-icon {
  height: 17px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 12px;
  color: #343B49;
  line-height: 17px;
  display: flex;
  align-items:center;
  display: flex;
  align-items: center;
  text-align: right;
  width: 100%;
  justify-content: flex-end;
}
.icon-more-detail {
  width: 10px;
  height: 10px;
  margin-left: 5px;
}
.data-footer {
  height: 54px;
  background: linear-gradient( 180deg, #F7F9FD 0%, #FFFFFF 100%);
  border-radius: 0px 0px 4px 4px;
  padding: 8px 10px;
}
.footer {
  height: 24px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 16px;
  color: #111824;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  display: flex;
  align-items:center;
}
.crile {
  width: 8px;
  height: 8px;
  background-color: #0165FF;
  border-radius: 50%;
  margin-right: 5px;
}
.o6 {
  opacity: .6;
}
.w130{
  width: 130px;
}
.footer-num {
  height: 24px;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 16px;
  color: #FF7001;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  font-weight: 700;
  margin-left: 5px;
}
.w-name {
  width: calc(100% - 130px);
}
.icon-zb {
  width: 60px;
  height: 42px;
}
.new-top {
  background-image: url('@/assets/images/矩形@2x.png');
  padding: 10px;
  display: flex;
  justify-content: space-between;
}

/* 表格样式 */
.table-content {
  width: 100%;
}
.table-content >>> .el-table__body-wrapper {
  overflow-y: auto !important;
  scroll-behavior: smooth;
}
.table-content >>> .el-table__body tr:hover > td {
  background-color: #bdd4f8 !important;
}
.hover-red:hover {
  color: #ff0000;
}
@media (max-width: 960px) {
  .shujujiaoyi {
    overflow: hidden;
  }
  .new-top {
    flex-wrap: nowrap;
    align-items: center;
    gap: 6px;
    padding: 8px 4px;
  }
  .icon-zb {
    width: 36px;
    height: 26px;
  }
  .title-text {
    font-size: 15px;
  }
  .more-text {
    font-size: 12px !important;
  }
  .hot-bottom {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    width: 100%;
  }
  .hot-bottom > .hot-bottom {
    display: contents;
  }
  .data-card {
    width: 100%;
    margin: 0;
    height: auto;
    min-height: 0;
    border-radius: 10px;
    overflow: hidden;
  }
  .data-title {
    height: 46px;
  }
  .data-detail {
    height: auto;
    min-height: 72px;
    padding: 8px;
    font-size: 12px;
    line-height: 20px;
  }
  .data-footer {
    height: auto;
    padding: 8px;
  }
  .footer {
    font-size: 12px;
  }
  .footer-num {
    font-size: 13px;
  }
  .data-name {
    font-size: 14px;
  }
  .data-card:nth-child(3n) {
    margin-right: 0;
  }
  .data-card:hover {
    transform: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
  .data-title {
    height: auto;
    min-height: 42px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    padding: 8px;
    gap: 4px;
  }
  .data-name {
    flex: none;
    width: 100%;
    height: auto;
    font-size: 13px;
    line-height: 1.3;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .data-type.is-wait {
  background: #8A9099;
}
.data-type {
    max-width: 100%;
    height: 18px;
    padding: 0 6px;
    font-size: 10px;
    line-height: 18px;
  }
  .data-detail {
    height: auto;
    min-height: 0;
    padding: 8px;
    font-size: 12px;
    line-height: 1.4;
  }
  .detail {
    -webkit-line-clamp: 2;
    line-height: 1.4;
    font-size: 11px;
  }
  .detail-icon {
    font-size: 11px;
    margin-top: 6px;
  }
  .data-footer {
    height: auto;
    padding: 6px 8px 8px;
  }
  .footer {
    height: auto;
    min-height: 18px;
    font-size: 11px;
    line-height: 1.3;
    flex-wrap: wrap;
    gap: 2px;
  }
  .w130 {
    width: auto;
    flex: 0 0 auto;
  }
  .w-name {
    width: auto;
    flex: 1 1 60px;
    min-width: 0;
    font-size: 11px;
  }
  .footer-num {
    font-size: 12px;
    height: auto;
    line-height: 1.3;
  }
  .crile {
    width: 5px;
    height: 5px;
  }
}
</style>